import { SettingsConstant } from "./../../../constants/settings.constants";
import { environment } from "@env/environment";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  OnDestroy
} from "@angular/core";
import { DropDownService } from "./services/drop-down.service";
import { LoaderService } from "./../../../../core/services/loader.service";
import { BroadcasterService } from "./../../../../core/services/broadcaster.service";
import { GenericUtils } from "./../../../utilities/";
import { LocalStorageService } from "./../../../services/local-storage.service";
import { MessageService } from './../../../services/message-service';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-drop-down-filter",
  templateUrl: "./drop-down.component.html",
  styleUrls: ["./drop-down.component.scss"]
})
export class DropDownFilterComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  filterData = [];
  unSortedData = [];
  dropDownForm: FormGroup;
  /** this.localStorage.getItem(
    `${environment.env}_${SettingsConstant.LOCALSTORAGE_KEYS.USER_UUID}`
    )**/
  @Input() apiUrl: string = "";
  @Input() data: [] = [];
  @Input() model: string = "";
  @Input() filterKey: string = "";
  @Input() queryParams: object = {};
  @Output() valueChanged = new EventEmitter();
  @Output() ddClickedEvent = new EventEmitter();
  @Input() placeholder: any;
  baseUrl = environment.gateWayHost;
  @Input() label: string = "";
  @Input() divClass: string = "";
  @Input() resetValue;
  @Input() validFilters = [];
  @Input() validFiltersSkip = false;
  @Input() defaultValue;
  @Input() index = '';
  @Input() label_code;
  @Input() label_name;
  @Input() typeOfdata;
  dropDownModel = null;
  constructor(
    private dropDownService: DropDownService,
    private loader: LoaderService,
    private broadcast: BroadcasterService,
    private genericUtils: GenericUtils,
    private localStorage: LocalStorageService,
    private cd: ChangeDetectorRef,
    private message: MessageService,
    private formBuilder: FormBuilder
  ) { }
  ngOnInit() {
    this.message.getMessage().pipe(takeUntil(this.unsubscribe)).subscribe(message => {
      if (message && message.filterReset) {
        this.dropDownForm.controls[this.model].patchValue('ALL');
        this.refreshValue("ALL");
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model && changes.model.isFirstChange) {
      this.dropDownForm = this.formBuilder.group({ [this.model]: [''] });
      if ((this.defaultValue || typeof this.defaultValue === 'boolean') && this.data && this.data.length) {
        const dataExist = this.data.filter(modelData => String(modelData['value']) === this.defaultValue);
        if (dataExist.length) {
          this.dropDownForm.controls[this.model].patchValue(dataExist[0]);
        }
      }
      if (typeof this.defaultValue !== 'boolean' && !this.defaultValue) {
        this.dropDownForm.controls[this.model].patchValue('ALL');
      }
    }
    if (changes['validFilters'] && JSON.stringify(changes['validFilters']['currentValue']) != JSON.stringify(changes['validFilters']['previousValue']) && !changes['validFilters']['firstChange']) {
      this.filterData = [];
      this.setValidFilters();
    }
    if (this.apiUrl && !this.resetValue) {
      this.getDataFromApi();
    }

    if (this.data) {
      this.filterData = this.data;
    }
    if (this.resetValue && this.filterData.length) {
      this.dropDownForm.controls[this.model].patchValue(null);
      this.refreshValue("ALL");
    }
    this.cd.detectChanges();
  }

  setValidFilters() {
    let filterWithData = [];
    let filterWithoutData = [];
    this.unSortedData.map(element => {
      let __element = "";
      if(typeof(element) == 'object' && element){
        let a = element[this.label_name] || 'Default';
        let b = element[this.label_code] || 'Default';
        __element = a + ' / ' + b;
      }else {
        __element = element;
      }

      if (this.validFilters.includes(element) || this.validFiltersSkip) {
        filterWithData.push({ 'label': __element, 'value': __element, 'disabled': false })
      } else {
        filterWithoutData.push({ 'label': element, 'value': element, 'disabled': true })
      }
    })

    this.filterData = filterWithData.concat(filterWithoutData);
    // if (this.typeOfdata == 'array') {
      this.filterData.unshift({ 'label': 'ALL', 'value': '', 'disabled': false });
    // }
    // else {
    //   this.filterData.unshift({ 'label': { 'client_facility_name': "ALL", "client_facility_code": "" }, 'value': { 'client_facility_name': "", "client_facility_code": "" }, 'disabled': false }); //need to change
    // }
    if (this.defaultValue && !this.resetValue) {
      this.dropDownForm.controls[this.model].patchValue(this.defaultValue);
    } else {
      this.dropDownForm.controls[this.model].patchValue('ALL');

    }
    //this.dropDownForm.controls.dropDownModel.patchValue('Spares');
  }

  getDataFromApi() {
    // this.loader.start();
    const option = {
      method: "GET",
      url: `${this.baseUrl}${this.apiUrl}`,
      query:
        this.queryParams && Object.keys(this.queryParams).length
          ? this.genericUtils.cleanParameters(this.queryParams)
          : {}
    };
    this.filterData = [];
    this.dropDownService
      .getDropDownData(this.genericUtils.cleanParameters(option))
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        (response: any) => {

          this.loader.stop();

          if (
            response["data"] &&
            Array.isArray(response["data"]) &&
            response["data"].length
          ) {
            this.unSortedData = response["data"][0]["filters"];
            this.setValidFilters();
            // this.filterData = unSortedData;
          }
        },
        error => {
          this.filterData.push({ 'label': 'ALL', 'value': '', 'disabled': false });
          this.loader.stop();
        }
      );
  }

  refreshValue(value) {
    if (value) {
      let finalValue = '';
      if (value === "ALL") {
        finalValue = "ALL";
        this.dropDownForm.controls[this.model].patchValue(finalValue);
      }
      
      else {
      // this.broadcast.publish('delhivery_filter', {model: this.model, value: value.text});
      let slash = value.label[this.label_name] && value.label[this.label_code] ? '/':''
      finalValue = value['value'] && value['label'][this.label_code] || value['label'][this.label_name]?
        {
          label: `${value.label[this.label_code]}${slash}${value.label[this.label_name]}`,
          value: `${value.label[this.label_code]}${slash}${value.label[this.label_name]}`, disabled: value.disabled
        }
        : value;
      };
      this.valueChanged.emit({
        model: this.model,
        value: finalValue,
        filterKey: this.filterKey || "",
        defaultValue: value === 'ALL' ? null : this.defaultValue
      })
    }
  }
  public click(value: any) {
    this.ddClickedEvent.emit(true);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
